import React from 'react'
import PropTypes from 'prop-types'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Text } from 'shared/components'
import styles from './styles'

const DropdownItem = ({
  css,
  icon,
  text,
  onClick,
  arrowDirection = 'right',
}) => {
  return (
    <div css={[styles.container, css]} onClick={onClick}>
      {icon()}
      <Text size={11}>{text}</Text>
      <FontAwesomeIcon icon={`caret-${arrowDirection}`} css={styles.arrow} />
    </div>
  )
}

DropdownItem.propTypes = {
  isOpen: PropTypes.bool,
  css: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  text: PropTypes.string,
  icon: PropTypes.func,
  onClick: PropTypes.func,
  arrowDirection: PropTypes.string,
}

export default DropdownItem
